import HeaderUser from '@/components/header-user'
import './header.css'
export default {
  name:'system-hader',
  render(){
    return (
      <ALayoutHeader class='header'>
        <div class="header-logo">
          <img src={this.$store.state.application.info.logo} />
        </div>
        <HeaderUser></HeaderUser>
      </ALayoutHeader>
    )
  }
}
